import './styles.css';
const Service = ({url, children}) => {
        return (
        <div className="cardService">
            <img src={url}  className="seviceImage"/>
            <div className='w-100 mt-0'><b className='serviceText' style={{}}>{children}</b></div>
        </div>
        )
}
export default Service; 